import { requestJson } from '../common/http';
import type { ApplyWorkLogsCommand, ApplyWorkLogsResponse } from './models';

export const applyWorkLogs = (cmd: ApplyWorkLogsCommand): Promise<ApplyWorkLogsResponse> =>
    requestJson<ApplyWorkLogsResponse>({
        method: 'PUT',
        path: '/work-logs/apply',
        body: cmd,
    });
